import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import FireStoreParser from 'firestore-parser';
import { DataContext } from '../context/data-context';

const sortByJersey = (players) =>
  players.sort((a, b) => {
    if (a.number < b.number) return -1;
    if (a.number > b.number) return 1;
    return 0;
  });

const sortByPositionAndJersey = (players) => ({
  goalkeepers: sortByJersey(players.filter((p) => p.position === 'Goalkeeper')),
  defenders: sortByJersey(
    players.filter((p) =>
      ['Back', 'Centre-Back', 'Left-Back', 'Right-Back'].includes(p.position)
    )
  ),
  midfields: sortByJersey(
    players.filter((p) =>
      [
        'Midfield',
        'Defensive Midfield',
        'Central Midfield',
        'Attacking Midfield',
        'Attacking Central Midfield',
        'Left Winger',
        'Right Winger',
      ].includes(p.position)
    )
  ),
  forwards: sortByJersey(
    players.filter((p) => ['Forward', 'Centre Forward'].includes(p.position))
  ),
});

export const useSquad = (abbrv) => {
  const { endpointUrl } = useContext(DataContext);
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${endpointUrl}data-endpoint/team/squad?id=${abbrv}`)
      .then((response) => {
        setData(FireStoreParser(response.data?.documents[0])?.fields?.players);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [abbrv, endpointUrl, setData]);

  const squad = !loading && !error ? sortByPositionAndJersey(data) : null;

  return [squad, loading, error];
};
